import { Component, Input, OnInit } from '@angular/core';
import { CustomerInterface } from '../../../account/models/customer.interface';
import { LandLineListInterface } from '../../models/land-line-list.interface';
import { LandLineProcedureInterface } from '../../models/land-line-procedure.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { select, Store } from '@ngrx/store';
import { CustomerStorageService } from '../../../account/services/customer-storage.service';
import { SelectedLandLineInterfaceState } from '../../store/state/selected-land-line.state';
import { GetLandLineProcedures } from '../../store/actions/land-line-procedures.actions';
import { DisplayProcedureMessageService } from '../../../lines/services/display-procedure-message.service';
import { LandLineProcedureInterfaceState } from '../../store/state/land-line-procedure.state';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';

@Component({
  selector: 'app-land-line-management',
  templateUrl: './land-line-management.component.html',
  styleUrls: ['./land-line-management.component.css'],
  standalone: false
})
export class LandLineManagementComponent implements OnInit {

  @Input()
  procedureInParam: string;

  customer: CustomerInterface;
  selectedLine: LandLineListInterface;
  proceduresList: Array<LandLineProcedureInterface> = [];
  selectedProcedure: string = null;
  lastMessage: Array<any>|null;
  constHelper = ConstsHelper;
  inProgressProceduresList: Array<LandLineProcedureInterface>;
  allProceduresList: Array<LandLineProcedureInterface>;

  constructor(
    private store: Store<any>,
    private customerStorageService: CustomerStorageService,
    public displayProcedureMessageService: DisplayProcedureMessageService,
    ) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE)).subscribe((response: SelectedLandLineInterfaceState) => {
      if (response.line.phoneNumber != null && (this.selectedLine === undefined || response.line.phoneNumber !== this.selectedLine.phoneNumber) && window.location.href.includes('gestion')) {
        this.selectedLine = response.line;
        this.proceduresList = [];
        this.inProgressProceduresList = [];
        this.allProceduresList = [];
        this.store.dispatch(new GetLandLineProcedures(this.selectedLine.phoneNumber));
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINE_PROCEDURES)).subscribe((response: LandLineProcedureInterfaceState) => {
      if (null !== response.landLineProcedures && this.selectedLine !== undefined && this.selectedLine !== null) {
        this.allProceduresList = response.landLineProcedures;
        for (const procedure of response.landLineProcedures) {
          if (procedure.status === 'finished' || procedure.status === 'disabled' || procedure.status === 'wait_form') {
            this.proceduresList.push(procedure);
          } else {
            this.inProgressProceduresList.push(procedure);
          }
        }
      }
    });

    this.proceduresList = [];
    this.inProgressProceduresList = [];
    this.customer = this.customerStorageService.getCustomer();
    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });
  }

  getProcedure(procedure: LandLineProcedureInterface) {
    if (procedure.code === this.constHelper.PROCEDURE_LANDLINE_MAT_TRACKING) {
      window.open(procedure.lastMessage['data']['url'], '_blank');
    } else {
      this.lastMessage = procedure.lastMessage;
      this.store.dispatch(new UpdateSelectedProcedure(procedure.code));
    }
  }

  getInProgressProcedure(procedure: LandLineProcedureInterface) {
    this.displayProcedureMessageService.displayInProgressMessage(procedure);
  }
}
